// product grid/list
// function listgridJavascript() {
// Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
//     link.addEventListener('click', function(event) {
//         Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
//         this.classList.add('active');
//         if(this.classList.contains('listv')){
//             document.getElementById('product-grid').classList.add('product-list');
//             document.getElementById('product-grid').classList.remove('product-grid');
//         }else if(this.classList.contains('gridv')){
//             document.getElementById('product-grid').classList.add('product-grid');
//             document.getElementById('product-grid').classList.remove('product-list');
//         }
//     });
// });
// };
// document.addEventListener("shopify:section:load", listgridJavascript);
// listgridJavascript();


function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();

// Viewport-aware autoplay video control.
// Avoid a document-level scroll handler and layout reads on every scroll frame.
let wbVideoObserver;
function initViewportAutoplayVideos() {
  const videos = Array.from(document.querySelectorAll('video[autoplay]'))
    .filter((video) => video.dataset.itVideoObserved !== '1');
  if (!videos.length || !('IntersectionObserver' in window)) return;

  if (!wbVideoObserver) {
    wbVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !document.hidden) {
          const promise = video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5] });
  }

  videos.forEach((video) => {
    video.dataset.itVideoObserved = '1';
    wbVideoObserver.observe(video);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initViewportAutoplayVideos, { once: true });
} else {
  initViewportAutoplayVideos();
}
document.addEventListener('shopify:section:load', initViewportAutoplayVideos);

// Countdown timers only run on pages that actually contain a countdown.
let wbCountdownTimer = null;
function setCountdownValue(section, selector, value) {
  const node = section.querySelector(selector);
  if (node) node.textContent = value;
}
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  if (!countCardSections.length) {
    if (wbCountdownTimer) clearInterval(wbCountdownTimer);
    wbCountdownTimer = null;
    return;
  }

  const now = Date.now();
  countCardSections.forEach((countdownSection) => {
    const countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    const distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      setCountdownValue(countdownSection, '.main_cdays .wb_cdays', '00');
      setCountdownValue(countdownSection, '.main_chours .wb_chours', '00');
      setCountdownValue(countdownSection, '.main_cminutes .wb_cminutes', '00');
      setCountdownValue(countdownSection, '.main_cseconds .wb_cseconds', '00');
      return;
    }
    setCountdownValue(countdownSection, '.main_cdays .wb_cdays', Math.floor(distance / (1000 * 60 * 60 * 24)));
    setCountdownValue(countdownSection, '.main_chours .wb_chours', Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    setCountdownValue(countdownSection, '.main_cminutes .wb_cminutes', Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
    setCountdownValue(countdownSection, '.main_cseconds .wb_cseconds', Math.floor((distance % (1000 * 60)) / 1000));
  });
}
function initCountdowns() {
  if (wbCountdownTimer) {
    clearInterval(wbCountdownTimer);
    wbCountdownTimer = null;
  }
  if (!document.querySelector('.countd_all')) return;
  countDown();
  wbCountdownTimer = setInterval(countDown, 1000);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdowns, { once: true });
} else {
  initCountdowns();
}
document.addEventListener('shopify:section:load', initCountdowns);
